var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0C21.4771 0 0 21.6065 0 48C0 74.5229 21.4773 96 48 96C74.5227 96 96 74.3928 96 48C96 21.6072 74.5227 0 48 0ZM69.4773 55.1159H45.8008C43.3423 55.1159 41.272 53.0456 41.272 50.5871V23.4173C41.272 20.9589 43.3423 18.8886 45.8008 18.8886C48.2592 18.8886 50.3295 20.9589 50.3295 23.4173V45.9297H69.6074C72.0658 45.9297 74.1361 48 74.1361 50.4585C74.0053 53.0449 72.065 55.1152 69.4775 55.1152L69.4773 55.1159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1e046eb2573b7dcd8b7804e71cfb492a.svg";
export { ForwardRef as ReactComponent };